<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Inclusión
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" :sm="ii > 1 ? 9 : 12">
                        <v-row align="center">
                            <v-col cols="12">
                                <v-stepper v-model="ii" vertical class="removeBorder">
                                    <!-- Certificados -->
                                    <v-stepper-step :complete="ii > 1" step="1"> Escoger Vehículo </v-stepper-step>

                                    <v-stepper-content step="1">
                                        <v-row dense align="center" justify="center">
                                            <v-col cols="12" sm="4" v-for="(v,k) in listGeneral.detalle" :key="k">
                                                <v-tooltip bottom color="primary">
                                                    <template v-slot:activator="{ on }">
                                                        <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on"></v-img>
                                                    </template>
                                                    <span>
                                                        <table width="100%">
                                                            <tbody>
                                                                <tr>
                                                                    <td> <strong class="white--text body-2">Marca: </strong> </td>
                                                                    <td class="body-2" v-html="v.marca"> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td> <strong class="white--text body-2">Modelo: </strong> </td>
                                                                    <td class="body-2" v-html="v.modelo"> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td> <strong class="white--text body-2">Año: </strong> </td>
                                                                    <td class="body-2" v-html="v.anio"> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td> <strong class="white--text body-2">Cédula: </strong> </td>
                                                                    <td class="body-2" v-html="v.numeroDocumento"> </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </span>
                                                </v-tooltip>
                                                <div class="text-center">
                                                    <h3 class="headline">Placa: {{ v.placa }}</h3>
                                                </div>
                                                <v-btn block rounded dark color="primary" @click="inclusion(v)">Realizar Inclusión</v-btn>
                                            </v-col>
                                        </v-row >
                                        <v-row  dense>
                                            <v-col class="text-right">
                                                <!-- <v-btn color="primary" v-show="!cycle" rounded dark @click="++ii">Siguiente </v-btn> -->
                                            </v-col>
                                        </v-row >
                                    </v-stepper-content>
                                    <!-- Agregar Accesorios -->
                                    <v-stepper-step :complete="ii > 2" step="2"> Agregar Accesorios </v-stepper-step>

                                    <v-stepper-content step="2">
                                        <StepperAccesoriosComponent :load="ii == 2 ? true : false" :listGeneral="listGeneral"
                                            :parametros="parametros" :objModal="objModal" :cycle="cycle" ref="chilAcce" />

                                        <v-row dense>
                                            <v-col class="text-right">
                                                <v-btn outlined rounded color="danger" class="mr-1" @click="--ii">Anterior</v-btn>
                                                <v-btn rounded dark color="primary" @click="++ii">Siguiente</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>

                                    <!-- Datos de Factura -->
                                    <v-stepper-step :complete="ii > 3" step="3"> Datos de Factura </v-stepper-step>

                                    <v-stepper-content step="3">
                                        <StepperDatosFacturaComponent :listGeneral="listGeneral"
                                            :objFormFactura="objFormFactura" :activo="ii == 3 ? true : false"
                                            :parametros="parametros" :disabled="disabled"
                                            :textoTerminoCondicionVenta="textoTerminoCondicionVenta" ref="chilCompFact"/>

                                        <v-layout xs12>
                                            <v-col class="text-right">
                                                <v-btn outlined rounded color="danger" @click="--ii" class="mr-1">Anterior</v-btn>
                                                <v-btn rounded dark color="primary" @click="onBotonPago" :disabled="_.size(listGeneral.listAccesorios) == 0 ? true : false">Realizar Pago</v-btn>
                                            </v-col>
                                        </v-layout>
                                    </v-stepper-content>
                                </v-stepper>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="3" v-show="ii > 1">
                        <InformacionValoresComponent :listGeneral="listGeneral" :parametros="parametros" :objModal="objModal" ref="chilPrima"/>
                    </v-col>
                </v-row>


            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'InclusionView',
        components:{
            StepperAccesoriosComponent: () => import('@/components/ajustePoliza/inclusion/vehiculo/StepperAccesoriosComponent.vue'),
            InformacionValoresComponent: () => import('@/components/ajustePoliza/inclusion/vehiculo/InformacionValoresComponent.vue'),
            StepperDatosFacturaComponent: () => import('@/components/ajustePoliza/inclusion/vehiculo/StepperDatosFacturaComponent.vue')
        },
        data: () => ({
            ii: 1,
            cycle: true,
            idCliente: null,
            listGeneral: {},
            parametros: {},
            objImpuestos: {},
            objOtros: {},
            objFormFactura:{},
            objModal: {
                abrirModal: false
            },
            disabled: false,
            textoTerminoCondicionVenta:''
        }),
        created() {
            this.idCliente = _.get(this.$root.obUsuario,'idCliente',null);
            axios.post(`${BASE_URI}administrador/inclusion-accesorio/cargaGeneral`,{})
                 .then((r) =>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.listGeneral = r.data.data.listas;
                        this.parametros = r.data.data.parametros;
                        this.$set(this.listGeneral, 'cabeceraModal', [{ value: 'nombre_accesorio', text: 'Objeto Asegurado' }, { value: 'valorAsegurado', text: 'Valor Asegurado'}]);
                        return this.onListarCertificados('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 });
        },
        methods: {
            apiSend(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto);
            },
            onListarCertificados(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'LISTAR_CERTIFICADOS_FOR_INCLUSION',
                        idCliente: _.get(this, 'idCliente', null)
                    };

                    var error = 'E';
                    this.$set(this.listGeneral, 'detalle', []);

                    return this.apiSend('administrador/certificado/listar', objeto)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw r.data.mensaje; } 
                              this.$set(this.listGeneral, 'detalle', _.map(r.data.data,(v) => { v.index = _.uniqueId();  return v; }));
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        })
                }
            },
            inclusion(objeto) {
                var o = { "opcion":"LISTAR_INCLUSION", "idProducto": _.get(objeto,'idProducto',null) };
                this.textoTerminoCondicionVenta = '';
                var error = 'E';

                if(parseInt(objeto.index) != parseInt(this.objModal.index)){
                  this.objImpuestos = {};
                  this.objOtros = {};
                  this.objFormFactura ={};
                  this.listGeneral.listAccesorios = [];
                }

                axios.post(`${BASE_URI}administrador/producto-parametro/listar`,o)
                     .then((r)=>{
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw r.data.mensaje; } 
                            this.textoTerminoCondicionVenta = _.get(r.data.data,['0','textoTerminoCondicionInclusion'],'');
                            this.cycle = false;
                            this.objModal = _.merge({}, _.cloneDeep(objeto), { abrirModal: true });
                            ++this.ii;
                            this.objFormFactura = objeto;
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     });

            },
            insertarInclusion(objetoBotonPago) {
              var l = _.cloneDeep(_.get(this.listGeneral, 'listAccesorios', []));
              
              var lista        = _.filter(l,{'check':true});
              var keys = ['index','nombre_accesorio','icono_app','disabled','check','orden'];
              lista = _.map(_.cloneDeep(lista),_.partialRight(_.omit,keys));

              var solicitud    = !_.isUndefined(_.find(l, (v) => { return _.toNumber(v.genera_solicitud) == _.toNumber(1);  })) ? true : false

              var objImpuestos = this.$refs.chilPrima.objImpuestos;
              var objOtros     = this.$refs.chilPrima.objOtros;
              var objPrima     = this.$refs.chilPrima.objPrima;

              var k = [ 'idTipoPersona', 'idTipoDocumento', 'idCanton','numeroDocumento', 'nombreCliente', 'telefono', 'direccion', 'email' ];

                var objeto = _.merge(
                                        {opcion: 'I',poliza:(_.split(this.objModal.poliza,'-'))[0]},
                                        _.pick(this.objModal,['idCertificado','idPoliza','idSeguro','idProducto']),
                                        // idCertificado : _.get(this.objModal, 'idCertificado', null),
                                        // idPoliza      : _.get(this.objModal, 'idPoliza'     , null),
                                        // idSeguro      : _.get(this.objModal, 'idSeguro'     , null),
                                        // idProducto    : _.get(this.objModal, 'idProducto'   , null),                    
                                        {listAccesorios: lista},
                                        {datosFactura: _.merge({},
                                                            _.pick(this.objFormFactura,k), 
                                                            { 'datosImpuestos': _.merge({}, objImpuestos, objOtros) }, 
                                                            { 'datosPrima': _.merge({ 'tasa_recarga': this.objModal.tasa_recarga }, objPrima) }
                                                            ),
                                        solicitud: solicitud
                                        });

                this.disabled = true;
                this.apiSend('administrador/inclusion/insertOrUpdate', objeto)
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data','data'], [])) == 0) throw _.get(r,['data','mensaje'], mensajeEstandar.errorPeticion);
                        mensajeAlertaTiempo(r.data.mensaje + ' Recibira al email detallado los detalles de su inclusión.', 'S');
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    })
                    .catch((e) => {
                        this.disabled = false;
                        mensajesAlerta(e, 'E');
                    });
            },
            onBotonPago() {
                // var chilCompFact = this.$children[0].$children[0].$children[5].$children[2];
                var band = this.$refs.chilCompFact.validar();
                if(band){
                    this.objFormFactura = this.$refs.chilCompFact.objDatosFactura;
                    //Cuando el botón de pago responda que todo salio OK
                    var objeto = {
                        //data que retorna el servicio de pago
                    };
                    this.insertarInclusion(objeto);
                }
            }
        },
        provide() {
            return {
                apiSend: this.apiSend,
                inclusion: this.inclusion
            }
        }
    }

</script>
<style>
    .tab {
        width: 33.33%;
    }
    .removeBorder {
        box-shadow: none !important;
    } 
    .theme--dark.v-stepper{
        background: none !important;
    }

</style>